import InputSelect from '../InputSelect';

const InputSelectSearchable = (props: any) => <InputSelect {...props} isSearchable />;

export default InputSelectSearchable;
